import Base from './base'
import urls from 'config/urls'

class Test extends Base {
  find (opts) {
    return this.httpGet({
      url: urls.test.find,
      data: opts
    })
  }

  get (opts) {
    return this.httpGet({
      url: urls.test.get,
      data: opts
    })
  }

  create (opts) {
    return this.httpPost({
      url: urls.test.create,
      data: opts
    })
  }

  update (opts) {
    return this.httpPost({
      url: urls.test.update,
      data: opts
    })
  }

  delete (opts) {
    return this.httpPost({
      url: urls.test.delete,
      data: opts
    })
  }

  getTestResult (opts) {
    return this.httpGet({
      url: urls.test.getTestResult,
      data: opts
    })
  }

  getTestResultDetail (opts) {
    return this.httpGet({
      url: urls.test.getTestResultDetail,
      data: opts
    })
  }

  exportTestResultDetail (opts) {
    return this.httpDownload({
      url: urls.test.exportTestResultDetail,
      data: opts
    })
  }
}

export default new Test



// WEBPACK FOOTER //
// ./src/models/test.js